import { Box, Typography } from "@mui/material";
import {
  RO_DETAIL_COLORS,
  RO_DETAIL_FONT,
} from "../../data/inRepairRoDetailConstants";

const RoDetailSectionLabel = ({ children, extra }) => (
  <Typography
    sx={{
      fontSize: RO_DETAIL_FONT.sectionLabel,
      fontWeight: "var(--font-semibold)",
      color: RO_DETAIL_COLORS.mutedText,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      mb: 1,
    }}
  >
    {children}
    {extra && (
      <Box
        component="span"
        sx={{
          fontSize: RO_DETAIL_FONT.sectionLabelExtra,
          color: RO_DETAIL_COLORS.mutedText,
          fontWeight: "var(--font-regular)",
          ml: 0.5,
          textTransform: "none",
        }}
      >
        {extra}
      </Box>
    )}
  </Typography>
);

export default RoDetailSectionLabel;
